import { setCss } from './functions.js';

export default function InfocardCarouselModule(element) {

    let delay = 10000;

    const swiper = new Swiper(element, {
        // configure Swiper to use modules
        slidesPerView: 1,
        mousewheel: {
            forceToAxis:true,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        autoplay: {
            delay: delay,
        },
        on: {
            slideChange: function(arg1) {
            },
            autoplayStop: function() {
            },
        }
    });

    return this;
}

window.modules = window.modules || {}
window.modules.InfocardCarouselModule = InfocardCarouselModule;
